import React from "react";

class ClientsReview extends React.Component {
  render() {
    return (
      <>
        <div className="section-full mobile-page-paddings ptb_40 pt__0 bg-repeat">
          <div className="container">
            <div className="section-content">
              <div className="qpqq sdfghjkl-case">
                <div className="row align-items-center">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="bg-white mb__0">
                      <div className="case-banner">
                        <h2 class="ert678 mb__15">Client's Review</h2>
                      </div>
                      <p>
                        “Partnering with shadow infosystem has been a
                        game-changer for our real estate business. As a company
                        in a highly competitive and dynamic industry, we needed
                        a digital presence that could set us apart and
                        effectively engage with our target audience. Shadow
                        infosystem delivered beyond our expectations, helping us
                        achieve significant growth through their comprehensive
                        digital strategies.”
                      </p>
                      <h6>Sandeep Kumar, Owner</h6>
                      <p className="mb__0">300 Experts</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ClientsReview;
